import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store';
import axios from "axios";

import vuetify from './plugins/vuetify'

// axios defaults
// base url for Frontend Api
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = process.env.VUE_APP_DEVELOPMENT_API_ENDPOINT;
}
else {
    axios.defaults.baseURL = window.location.origin + '/api/';
}

// Include cookie credentials with every request
axios.defaults.withCredentials = true;
axios.defaults.headers.common['x-csrf'] = '1'   // force cors by adding header element

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
},
    async function (error) {
        console.error("[main] axios.interceptors.response error", error);
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        if (401 === error.response.status) {
            await store.dispatch('LogOut');
        }

        return Promise.reject(error);

    });

Vue.config.productionTip = false;

router.push({
    name: 'buildings',
})

new Vue({
    router,
    vuetify,
    store: store,
    render: h => h(App)
}).$mount('#app');


